import { styled } from '@clickcease/cc-client-components-lib'

export const BundlePlanMobileStyled = styled('div', {
  display: 'flex',
  width: '100px',
  height: '100px',
  paddingTop: '$5',
  borderRadius: '10px',
  boxShadow: '0px 0px 18.6425px rgba(80, 54, 123, 0.13)',
  flexDirection: 'column',
  alignItems: 'center',
  border: '2px solid transparent',
})

export const BundlePlanMobileName = styled('div', {
  fontWeight: '$sb',
  fontSize: '$lg',
})

export const BundlePlanMobilePriceWrapper = styled('div', {
  display: 'flex',
  marginRight: '4px',
})

export const BundlePlanMobilePrice = styled('div', {
  fontWeight: '$sb',
  fontSize: '$lg',
})

export const BundlePlanMobileCurrency = styled('div', {
  fontWeight: '$r',
  fontSize: '$lg',
})

export const BundlePlanMobilePeriod = styled('div', {
  fontWeight: '$r',
  fontSize: '$lg',
})

export const BundlePlanMobileBilledAnnually = styled('div', {
  fontWeight: '$r',
  fontSize: '$sm',
  marginTop: '$2',
})

export const BundlePlanMobileLetsTalk = styled('div', {
  fontWeight: '$r',
  fontSize: '$lg',
  marginTop: '$8',
})
